module.exports = __webpack_public_path__ + "static/72gde-ddedb4c3c5d69c0a4ed4b08993895d76.gif";